import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AdminEnquiries from './pages/AdminEnquiries';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/enquiries" element={<AdminEnquiries />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;